export function stringOrUndefined(x: unknown): string | undefined {
  if (typeof x === "string") return x
  return undefined
}
